import React, { ComponentProps } from 'react'
import BasePriceRowPrice from '../BasePriceRowPrice'
import LuxuryPlusLogo from 'loyalty/components/LuxuryPlusLogo'
import styled from 'styled-components'
import { rem } from 'polished'

const SpaceLuxuryPlusLogo = styled(LuxuryPlusLogo)`
  margin-inline-end: ${rem(2)};
`

type Props = Omit<ComponentProps<typeof BasePriceRowPrice>, 'priceColour' | 'priceHighlightColour' | 'priceLeading' | 'saleUnitColour'> & {
  /**
   * Prepend the price with the loyalty logo
   */
  withLogo?: boolean
}

function PriceRowLoyaltyPrice(props: Props) {
  const {
    withLogo,
    ...rest
  } = props

  return <BasePriceRowPrice
    {...rest}
    priceLeading={<>{withLogo && <SpaceLuxuryPlusLogo height={8} />}</>}
    priceColour="loyalty"
    saleUnitColour="loyalty"
  />
}

export default PriceRowLoyaltyPrice
